module.exports = __webpack_public_path__ + "img/SixToGo.535e57a6.svg";